import {Component, Injector, ViewEncapsulation} from "@angular/core";
import {BaseComponent} from "../../../ui/components/base/base.component";

@Component({
  selector: 'admin-menu-page',
  templateUrl: './admin.menu.page.component.html',
  styleUrls: ['./admin.menu.page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminMenuPageComponent extends BaseComponent {

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.disableLoading();
  }

}
